<pcp-slide-sync-toolbar-button
        [matIcon]="matIconName"
        [fontSet]="fontSet"
        (click)="undo()"
        [disabled]="(isDisabled$ | async) === true"
></pcp-slide-sync-toolbar-button>
